import type { Pair } from '../messages';

/** The settings screen: profile fields, appearance and language, password and session. */
export const settings = {
  'settings.theme': ['Тема интерфейса', 'Interface theme'],
  'settings.language': ['Язык интерфейса', 'Interface language'],
  'settings.languageHint': [
    'Выбор живёт в этом браузере и не зависит от аккаунта.',
    'Your choice lives in this browser, not in your account.',
  ],
  'settings.sectionAppearance': ['Внешний вид', 'Appearance'],
  'settings.sectionSecurity': ['Безопасность', 'Security'],
  'settings.sectionSession': ['Сессия', 'Session'],
  'settings.profileLinkNote': ['Профиль виден по ссылке', 'Your profile is visible at'],
  'settings.profileUpdated': ['Профиль обновлён', 'Profile updated'],
  'settings.nameRequired': ['Имя нельзя оставить пустым.', 'The name cannot be empty.'],
  'settings.displayName': ['Отображаемое имя', 'Display name'],
  'settings.displayNameHint': [
    'Так вас видят в подборках и ленте.',
    'How you appear in collections and the feed.',
  ],
  'settings.username': ['Имя пользователя', 'Username'],
  'settings.usernameHint': [
    'Часть ссылки на профиль: /u/имя. Латиница, цифры, дефис и подчёркивание.',
    'Part of your profile link: /u/name. Latin letters, digits, hyphen, underscore.',
  ],
  'settings.bio': ['О себе', 'About you'],
  'settings.bioHint': ['До 280 символов.', 'Up to 280 characters.'],
  'settings.avatar': ['Ссылка на аватар', 'Avatar link'],
  'settings.avatarHint': [
    'Картинка остаётся у того, кто её хостит — мы её не загружаем.',
    'The image stays with whoever hosts it — we do not upload it.',
  ],
  'settings.changeHandleTitle': ['Сменить имя пользователя?', 'Change your username?'],
  'settings.changeHandleBody': [
    (v) => `Старые ссылки вида /u/${v.username} перестанут работать. Подписки и подборки сохранятся.`,
    (v) => `Old links like /u/${v.username} stop working. Follows and collections stay.`,
  ],
  'settings.changeHandleYes': ['Да, сменить', 'Yes, change it'],
  'settings.passwordMismatch': ['Пароли не совпадают.', 'The passwords do not match.'],
  'settings.passwordShort': [
    'Новый пароль должен быть не короче 8 символов.',
    'The new password must be at least 8 characters.',
  ],
  'settings.passwordChanged': [
    'Пароль изменён. На других устройствах придётся войти заново.',
    'Password changed. Other devices will need to sign in again.',
  ],
  'settings.currentPassword': ['Текущий пароль', 'Current password'],
  'settings.newPassword': ['Новый пароль', 'New password'],
  'settings.passwordHint': ['Минимум 8 символов.', 'At least 8 characters.'],
  'settings.repeatPassword': ['Повторите новый пароль', 'Repeat the new password'],
  'settings.changing': ['Меняем…', 'Changing…'],
  'settings.changePassword': ['Изменить пароль', 'Change password'],
  'settings.sessionNote': [
    'Вход живёт в cookie этого браузера. «Выйти» закрывает только эту сессию — другие устройства остаются в системе. Смена пароля, наоборот, выкидывает все остальные входы, кроме этого.',
    'Signing in lives in this browser’s cookies. “Sign out” closes only this session — other devices stay signed in. Changing the password does the opposite: it kicks out every other sign-in but this one.',
  ],
  'settings.logout': ['Выйти', 'Sign out'],
  'settings.logoutTitle': ['Выйти из аккаунта?', 'Sign out of your account?'],
  'settings.logoutBody': [
    'Библиотека и подборки останутся на месте — достаточно войти снова.',
    'Your library and collections stay put — just sign in again.',
  ],
} satisfies Record<string, Pair>;
